import React, { Component } from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

export default class ButtonOutlineV2 extends Component {
  handleClick = (e) => {
    const { onClick, setModalTriggerHeight } = this.props

    onClick && onClick(e)
    if (setModalTriggerHeight) {
      setModalTriggerHeight(this.buttonRef.getBoundingClientRect().top)
    }
  }

  render() {
    const {
      icon,
      children,
      className,
      style,
      disabled,
      ...restProps
    } = this.props

    return (
      <BgWrapper
        innerRef={(ref) => (this.buttonRef = ref)}
        disabled={disabled}
        bgColor={backgroundColors.normalLeft}
        className={className}
        style={style}>
        <Wrapper disabled={disabled} {...restProps} onClick={this.handleClick}>
          {icon}
          {children}
        </Wrapper>
      </BgWrapper>
    )
  }
}

const BgWrapper = styled.div.attrs({ ref: (props) => props.buttonRef })`
  height: 40px;
  background: ${({ bgColor }) => bgColor};
  padding: 1px;
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    `
    background: #BABABA;
  `}
`

const Wrapper = styled.button`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  outline: 0;
  border: 0;
  background: #fff;

  color: var(--Gray, #3e3e3e);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;

  cursor: pointer;

  > svg,
  path {
    fill: #3e3e3e;
  }

  &:hover {
    background: #ececec;
    color: #006736;

    > svg,
    path {
      fill: #006736;
    }
  }

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;
    pointer-events: none;
    background: #ECECEC;
    color: #BABABA;
  `}
`



// WEBPACK FOOTER //
// ./src/components/ButtonOutlineV2/index.js